// extracted by mini-css-extract-plugin
export default {"status-indicator":"StatusIndicator_status-indicator__B4Kk4"};